import { Grid2 } from '@mui/material'
import React from 'react'

const CounselingService = () => {
  return (
    <section >
      <h2>Counseling Service</h2>
      <p>
        Dream College Path provides comprehensive college counseling tailored to each student’s unique strengths and aspirations. Our services empower students with the knowledge, tools, and confidence they need for success.
      </p>
      <h4>Our Core Services</h4>
      <Grid2 container columnSpacing={12}>
        <Grid2 item xs={12} md={6}>
          <div className='counseling'>
            <h4>One-on-One Counseling Sessions</h4>
            <ul>
              <li>Regular personalized video sessions with a dedicated counselor</li>
              <li>Goal setting and academic planning</li>
              <li>Support with extracurricular and time management strategies</li>
            </ul>
          </div>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <div className='counseling'>
            <h4>College Planning & Application Strategy</h4>
            <ul>
              <li>Personalized college list creation</li>
              <li>Application timeline planning and milestone tracking</li>
              <li>Support with early decision and early action strategies</li>
            </ul>
          </div>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <div className='counseling'>
            <h4>Essay Brainstorming & Review</h4>
            <ul>
              <li>Individual support to find your authentic story</li>
              <li>Review and feedback on Common App and supplemental essays</li>
              <li>Clarity, voice, and structure improvements</li>
            </ul>
          </div>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <div className='counseling'>
            <h4>Parent Engagement (Optional)</h4>
            <ul>
              <li>Scheduled progress updates to parents or guardians</li>
              <li>Joint sessions available when appropriate</li>
              <li>Support for navigating financial aid processes</li>
            </ul>
          </div>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <div className='counseling'>
            <h4>Live Projects & Resume Building</h4>
            <ul>
              <li>Access to curated research, leadership, and volunteering opportunities</li>
              <li>Mentorship for building a strong academic and extracurricular profile</li>
              <li>Resume development for college and scholarship applications</li>
            </ul>
          </div>
        </Grid2>
      </Grid2>
      <div className='counseling'>
        <h4>Who This Is For</h4>
        <ul>
          <li>High school students from grades 9 through 12</li>
          <li>Students aiming for top U.S. and international universities</li>
          <li>Families seeking personalized, long-term college preparation</li>
          <li>Students exploring academic interests and career paths</li>
        </ul>
      </div>
      <div className='counseling'>
        <h4>Why Dream College Path?</h4>
        <ul>
          <li><strong>Student-Centered Counseling</strong>: Every session is personalized based on the student’s needs and aspirations</li>
          <li><strong>Experienced Counselors:</strong>: Our team brings proven expertise in college admissions and mentorship</li>
          <li><strong>Holistic Development:</strong> We help students build strong academic, extracurricular, and personal profiles</li>
          <li><strong>Clear Communication:</strong>Parents and students stay informed through regular updates and access to milestones</li>
        </ul>
      </div>
      <div>
        <h4>
          Start Your Journey With Us
        </h4>
        <p>
          Book a free introductory session to learn how our personalized approach can help you reach your college goals.
          Register with us Or email us at <a href='mailto:info@dreamcollegepath.com'>info@dreamcollegepath.com</a>
        </p>
      </div>
    </section>
  )
}

export default CounselingService